
import generic from '../../../../Template/config/components/generic'
import AdNormSetsTab from './AdNormSetsTab'
import MainHeader from './MainHeader'
export default {
  ...generic,
  AdNormSetsTab,
  MainHeader
 }



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/generic/index.js